import React, { useCallback, useEffect, useState } from 'react'
import { CardList } from 'react-bootstrap-icons'
import axiosService from '../../../../utils/AxiosService'
import { POLL_INTERVAL_MS } from '../WaitingListParts/waitingListConstants'

const describe = ({ total, queued, retrying }) => {
  if (!total) return 'Influencer waiting list – nothing pending'
  const parts = [`${queued} queued`]
  if (retrying) parts.push(`${retrying} retrying`)
  return `Influencer waiting list – ${parts.join(', ')}`
}

export default function WaitingListButton({ onClick, refreshKey, className }) {
  const [counts, setCounts] = useState({ total: 0, queued: 0, retrying: 0 })

  const load = useCallback(() => {
    axiosService.get('/api/project_manager/authentications/modash_processables_count')
      .then(setCounts)
      .catch(() => {})
  }, [])

  useEffect(() => {
    const loadIfVisible = () => {
      if (document.visibilityState === 'visible') load()
    }

    load()
    const interval = setInterval(loadIfVisible, POLL_INTERVAL_MS)
    document.addEventListener('visibilitychange', loadIfVisible)
    window.addEventListener('focus', loadIfVisible)

    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', loadIfVisible)
      window.removeEventListener('focus', loadIfVisible)
    }
  }, [load, refreshKey])

  const pending = counts.total > 0
  const hasRetries = counts.retrying > 0

  return (
    <button type="button" onClick={onClick} title={describe(counts)} className={`relative ${className}`}>
      <CardList />
      Waiting list
      {pending && (
        <span className="pointer-events-none absolute -top-2 -right-2 flex h-5 min-w-[1.25rem]">
          <span key={counts.total} className={`absolute inset-0 rounded-full opacity-60 motion-safe:animate-ping [animation-iteration-count:3] ${hasRetries ? 'bg-amber-400' : 'bg-rb-green'}`} />
          <span
            className={`relative flex h-5 min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-[11px] font-bold leading-none text-white shadow-sm ring-2 ring-white dark:ring-rb-dark-mode ${hasRetries ? 'bg-amber-500' : 'bg-rb-green dark:text-rb-dark-mode'}`}
          >
            {counts.total > 99 ? '99+' : counts.total}
          </span>
        </span>
      )}
    </button>
  )
}
